module.exports = __webpack_public_path__ + "static/media/movilidad-reducida.b50045b6.svg";